import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { $createParagraphNode, $getSelection, $insertNodes, $isRangeSelection } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Box } from "../../../../Box/index.js";
import { Icon } from "../../../../Icon/index.js";
import { DropdownButton } from "../../../../DropdownButton/index.js";
import { MenuItem } from "../../../../MenuItem/index.js";
import { Typography } from "../../../../Typography/index.js";
import { ToolbarButton } from "../common/index.js";
import { $createFileNode, $createImagesGalleryNode, $createSingleImageNode, $createVideoNode } from "../../nodes/index.js";
import { AddImageDialog } from "./AddImageDialog/index.js";
import { AddImagesGalleryDialog } from "./AddImagesGalleryDialog/index.js";
import { AddVideoDialog } from "./AddVideoDialog/index.js";
import { AddFileDialog } from "./AddFileDialog/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const MediaPlugin = (t0)=>{
    const $ = c(58);
    const { loadFile, onUploadError, singeImage, imagesGallery, video, file: filePlugin, mode } = t0;
    const [editor] = useLexicalComposerContext();
    const [isAddImageDialogOpened, setIsAddImageDialogOpened] = useState(false);
    const [isAddVideoDialogOpened, setIsAddVideoDialogOpened] = useState(false);
    const [isAddImageGalleryDialogOpened, setIsAddImageGalleryDialogOpened] = useState(false);
    const [isAddFileDialogOpened, setIsAddFileDialogOpened] = useState(false);
    const hasOneOfImagesNodes = (singeImage || imagesGallery) && !(singeImage && imagesGallery);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (state)=>()=>setIsAddImageDialogOpened(state);
        $[0] = t1;
    } else t1 = $[0];
    const handleAddImageDialogState = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (state_0)=>()=>setIsAddImageGalleryDialogOpened(state_0);
        $[1] = t2;
    } else t2 = $[1];
    const handleAddImageGalleryDialogState = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (state_1)=>()=>setIsAddVideoDialogOpened(state_1);
        $[2] = t3;
    } else t3 = $[2];
    const handleAddVideoDialogState = t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (state_2)=>()=>setIsAddFileDialogOpened(state_2);
        $[3] = t4;
    } else t4 = $[3];
    const handleAddFileDialogState = t4;
    let t5;
    if ($[4] !== editor || $[5] !== loadFile || $[6] !== mode || $[7] !== onUploadError) {
        t5 = (file, description)=>_async_to_generator(function*() {
                editor.read(()=>_async_to_generator(function*() {
                        const selection = $getSelection();
                        if ($isRangeSelection(selection)) try {
                            const { id, name } = yield loadFile(file.value, "image");
                            editor.update(()=>{
                                const singleImageNode = $createSingleImageNode(name, id, description, mode);
                                $insertNodes([
                                    singleImageNode
                                ]);
                            });
                        } catch (t6) {
                            onUploadError("\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437 \u043F\u043E\u0437\u0436\u0435", "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435");
                        }
                    })());
            })();
        $[4] = editor;
        $[5] = loadFile;
        $[6] = mode;
        $[7] = onUploadError;
        $[8] = t5;
    } else t5 = $[8];
    const handleAddImage = t5;
    let t6;
    if ($[9] !== editor || $[10] !== loadFile || $[11] !== onUploadError) {
        t6 = (files, description_0)=>_async_to_generator(function*() {
                editor.read(()=>_async_to_generator(function*() {
                        const selection_0 = $getSelection();
                        if ($isRangeSelection(selection_0)) try {
                            const images = yield Promise.all(files.map((image)=>loadFile(image.value, "image")));
                            editor.update(()=>{
                                const imagesGalleryNode = $createImagesGalleryNode(images, editor, description_0);
                                $insertNodes([
                                    imagesGalleryNode
                                ]);
                            });
                        } catch (t7) {
                            onUploadError("\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437 \u043F\u043E\u0437\u0436\u0435", "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0433\u0430\u043B\u0435\u0440\u0435\u044E \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0439");
                        }
                    })());
            })();
        $[9] = editor;
        $[10] = loadFile;
        $[11] = onUploadError;
        $[12] = t6;
    } else t6 = $[12];
    const handleAddImagesGallery = t6;
    let t7;
    if ($[13] !== editor || $[14] !== onUploadError) {
        t7 = (src, description_1)=>{
            editor.read(()=>{
                const selection_1 = $getSelection();
                if ($isRangeSelection(selection_1)) try {
                    editor.update(()=>{
                        const videoNode = $createVideoNode(src, description_1);
                        const paragraphNode = $createParagraphNode();
                        $insertNodes([
                            videoNode,
                            paragraphNode
                        ]);
                    });
                } catch (t8) {
                    onUploadError("\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437 \u043F\u043E\u0437\u0436\u0435", "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u0438\u0434\u0435\u043E");
                }
            });
        };
        $[13] = editor;
        $[14] = onUploadError;
        $[15] = t7;
    } else t7 = $[15];
    const handleAddVideo = t7;
    let t8;
    if ($[16] !== editor || $[17] !== loadFile || $[18] !== onUploadError) {
        t8 = (file_0)=>_async_to_generator(function*() {
                editor.read(()=>_async_to_generator(function*() {
                        const selection_2 = $getSelection();
                        if ($isRangeSelection(selection_2)) try {
                            const { id: id_0, name: name_0 } = yield loadFile(file_0.value, "file");
                            editor.update(()=>{
                                const fileNode = $createFileNode(id_0, name_0, file_0.value.size);
                                $insertNodes([
                                    fileNode
                                ]);
                            });
                        } catch (t9) {
                            onUploadError("\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437 \u043F\u043E\u0437\u0436\u0435", "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0444\u0430\u0439\u043B");
                        }
                    })());
            })();
        $[16] = editor;
        $[17] = loadFile;
        $[18] = onUploadError;
        $[19] = t8;
    } else t8 = $[19];
    const handleAddFile = t8;
    let t9;
    if ($[20] !== hasOneOfImagesNodes || $[21] !== singeImage) {
        t9 = singeImage && (hasOneOfImagesNodes ? /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: handleAddImageDialogState(true),
            tooltip: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
            children: /*#__PURE__*/ jsx(Box, {
                display: "flex",
                alignItems: "center",
                children: /*#__PURE__*/ jsx(Icon, {
                    name: "picture_outline",
                    size: "16",
                    color: "text.light.primary"
                })
            })
        }) : /*#__PURE__*/ jsx(MenuItem, {
            onClick: handleAddImageDialogState(true),
            children: /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignItems: "center",
                gap: "8",
                children: [
                    /*#__PURE__*/ jsx(Icon, {
                        name: "picture_outline",
                        size: "20",
                        color: "text.light.primary"
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "body3",
                        children: "Изображение"
                    })
                ]
            })
        }, "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435"));
        $[20] = hasOneOfImagesNodes;
        $[21] = singeImage;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== hasOneOfImagesNodes || $[24] !== imagesGallery) {
        t10 = imagesGallery && (hasOneOfImagesNodes ? /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: handleAddImageGalleryDialogState(true),
            tooltip: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
            children: /*#__PURE__*/ jsx(Box, {
                display: "flex",
                alignItems: "center",
                children: /*#__PURE__*/ jsx(Icon, {
                    name: "picture_stack_outline",
                    size: "16",
                    color: "text.light.primary"
                })
            })
        }) : /*#__PURE__*/ jsx(MenuItem, {
            onClick: handleAddImageGalleryDialogState(true),
            children: /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                alignItems: "center",
                gap: "8",
                children: [
                    /*#__PURE__*/ jsx(Icon, {
                        name: "picture_stack_outline",
                        size: "20",
                        color: "text.light.primary"
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "body3",
                        children: "Галерея изображений"
                    })
                ]
            })
        }, "\u0413\u0430\u043B\u0435\u0440\u0435\u044F \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0439"));
        $[23] = hasOneOfImagesNodes;
        $[24] = imagesGallery;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== t10 || $[27] !== t9) {
        t11 = [
            t9,
            t10
        ];
        $[26] = t10;
        $[27] = t9;
        $[28] = t11;
    } else t11 = $[28];
    const imageMenuItems = t11;
    let t12;
    if ($[29] !== hasOneOfImagesNodes || $[30] !== imageMenuItems || $[31] !== imagesGallery || $[32] !== singeImage) {
        t12 = (singeImage || imagesGallery) && (hasOneOfImagesNodes ? imageMenuItems : /*#__PURE__*/ jsx(DropdownButton, {
            menuItems: imageMenuItems,
            variant: "tertiaryLight",
            verticalPosition: "bottom",
            horizontalPosition: "left",
            button: _temp
        }));
        $[29] = hasOneOfImagesNodes;
        $[30] = imageMenuItems;
        $[31] = imagesGallery;
        $[32] = singeImage;
        $[33] = t12;
    } else t12 = $[33];
    let t13;
    if ($[34] !== video) {
        t13 = video && /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: handleAddVideoDialogState(true),
            tooltip: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u0432\u0438\u0434\u0435\u043E",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "video_square_outline",
                size: "16",
                color: "text.light.primary"
            })
        });
        $[34] = video;
        $[35] = t13;
    } else t13 = $[35];
    let t14;
    if ($[36] !== filePlugin) {
        t14 = filePlugin && /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: handleAddFileDialogState(true),
            tooltip: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0444\u0430\u0439\u043B",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "attach",
                size: "16",
                color: "text.light.primary"
            })
        });
        $[36] = filePlugin;
        $[37] = t14;
    } else t14 = $[37];
    let t15;
    if ($[38] !== handleAddImage || $[39] !== isAddImageDialogOpened) {
        t15 = isAddImageDialogOpened && /*#__PURE__*/ jsx(AddImageDialog, {
            open: isAddImageDialogOpened,
            onClose: handleAddImageDialogState(false),
            addImage: handleAddImage
        });
        $[38] = handleAddImage;
        $[39] = isAddImageDialogOpened;
        $[40] = t15;
    } else t15 = $[40];
    let t16;
    if ($[41] !== handleAddImagesGallery || $[42] !== isAddImageGalleryDialogOpened) {
        t16 = isAddImageGalleryDialogOpened && /*#__PURE__*/ jsx(AddImagesGalleryDialog, {
            open: isAddImageGalleryDialogOpened,
            onClose: handleAddImageGalleryDialogState(false),
            addImages: handleAddImagesGallery
        });
        $[41] = handleAddImagesGallery;
        $[42] = isAddImageGalleryDialogOpened;
        $[43] = t16;
    } else t16 = $[43];
    let t17;
    if ($[44] !== handleAddVideo || $[45] !== isAddVideoDialogOpened) {
        t17 = isAddVideoDialogOpened && /*#__PURE__*/ jsx(AddVideoDialog, {
            open: isAddVideoDialogOpened,
            onClose: handleAddVideoDialogState(false),
            addVideo: handleAddVideo
        });
        $[44] = handleAddVideo;
        $[45] = isAddVideoDialogOpened;
        $[46] = t17;
    } else t17 = $[46];
    let t18;
    if ($[47] !== handleAddFile || $[48] !== isAddFileDialogOpened) {
        t18 = isAddFileDialogOpened && /*#__PURE__*/ jsx(AddFileDialog, {
            open: isAddFileDialogOpened,
            onClose: handleAddFileDialogState(false),
            addFile: handleAddFile
        });
        $[47] = handleAddFile;
        $[48] = isAddFileDialogOpened;
        $[49] = t18;
    } else t18 = $[49];
    let t19;
    if ($[50] !== t12 || $[51] !== t13 || $[52] !== t14 || $[53] !== t15 || $[54] !== t16 || $[55] !== t17 || $[56] !== t18) {
        t19 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: "2",
            children: [
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18
            ]
        });
        $[50] = t12;
        $[51] = t13;
        $[52] = t14;
        $[53] = t15;
        $[54] = t16;
        $[55] = t17;
        $[56] = t18;
        $[57] = t19;
    } else t19 = $[57];
    return t19;
};
function _temp(t0) {
    const { onClick } = t0;
    return /*#__PURE__*/ jsx(ToolbarButton, {
        onClick: onClick,
        tooltip: "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
        children: /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: "2",
            children: [
                /*#__PURE__*/ jsx(Icon, {
                    name: "picture_outline",
                    size: "16",
                    color: "text.light.primary"
                }),
                /*#__PURE__*/ jsx(Icon, {
                    name: "dropdown",
                    size: "16",
                    color: "text.light.primary"
                })
            ]
        })
    });
}
export { MediaPlugin };
